import React from 'react';
import ReactDOM from 'react-dom';
import PreviewImage, { PreviewImageProps } from './previewImage';
import PageLoading, { PageLoadingProps } from './pageLoading';
import Loading from './loading';
import { PrintParams } from './interface';
import clientInitFun from './clientInit';
import printFun from './print';
import audioFun from './audio';

export interface MessageApi {
  previewImage: (props: PreviewImageProps) => void;
  pageLoading: (loading: PageLoadingProps) => void;
  loading: (loading: PageLoadingProps) => void;
  clientInit: () => void;
  print: (params: PrintParams) => void;
  audio: (message: string) => void;
}

const api: MessageApi = {
  previewImage: props => {
    const { onClose, getPopupContainer, } = props;
    const previewImageId = 'helper-wrapper';
    let el = document.getElementById(previewImageId);
    if (!el) {
      el = document.createElement('div');
      el.id = previewImageId;
      (getPopupContainer?.() || document.body).append(el);
    }
    const handleClock = () => {
      setTimeout(() => {
        el?.remove();
      }, 300);
      onClose?.();
    };
    ReactDOM.render(<PreviewImage {...props} onClose={handleClock} />, el);
  },
  pageLoading: props => {
    const previewImageId = 'page-loading-wrapper';
    let el = document.getElementById(previewImageId);
    if (!el) {
      el = document.createElement('div');
      el.id = previewImageId;
      document.body.append(el);
    }
    ReactDOM.render(<PageLoading {...props} />, el);
  },
  loading: props => {
    const previewImageId = 'page-loading-wrapper';
    let el = document.getElementById(previewImageId);
    if (!el) {
      el = document.createElement('div');
      el.id = previewImageId;
      document.body.append(el);
    }
    ReactDOM.render(<Loading {...props} />, el);
  },
  clientInit: () => clientInitFun(),
  print: (params: PrintParams) => printFun(params),
  audio: (message: string) => audioFun(message),
};

export default api;
